import Button from '../ui/Button'
import Badge from '../ui/Badge'
import DataCard from '../ui/DataCard'
import { heroContent } from '../../data/landing-content'

export default function Hero() {
  return (
    <section
      id="solutions"
      className="relative rounded-window p-18 overflow-hidden shadow-card text-[#f8fbff]"
      style={{
        background: 'linear-gradient(176deg, rgba(25, 35, 58, 0.92) 0%, rgba(37, 49, 78, 0.9) 35%, rgba(60, 90, 130, 0.88) 100%), url("https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1600&q=80") center/cover'
      }}
    >
      {/* Radial gradient overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 18% 18%, rgba(255, 255, 255, 0.16) 0%, transparent 58%)'
        }}
      />

      <div className="relative z-10 grid lg:grid-cols-[1.4fr_1fr] gap-12 items-start">
        {/* Hero Content */}
        <div className="flex flex-col gap-6 max-w-[560px]">
          <Badge>{heroContent.eyebrow}</Badge>

          <h1 className="text-[clamp(2.6rem,3.6vw+1rem,3.8rem)] leading-[1.1] tracking-[-0.035em] font-bold m-0">
            {heroContent.title}
          </h1>

          <p className="text-[1.05rem] leading-relaxed text-[rgba(241,246,255,0.88)] m-0">
            {heroContent.description}
          </p>

          <div className="flex gap-5 mt-1.5">
            <Button
              {...(heroContent.cta.primary as any)}
              variant="primary"
            >
              {heroContent.cta.primary.text}
            </Button>
            <Button
              {...(heroContent.cta.secondary as any)}
              variant="secondary"
              className="bg-[rgba(255,255,255,0.16)] text-[#f8fbff] hover:bg-[rgba(255,255,255,0.24)]"
            >
              {heroContent.cta.secondary.text}
            </Button>
          </div>
        </div>

        {/* Data Cards Grid */}
        <div className="grid grid-cols-2 gap-6">
          {heroContent.dataCards.map((card, idx) => (
            <DataCard key={idx} {...card} />
          ))}
        </div>
      </div>
    </section>
  )
}
